import _ from "lodash";

export const onHandleDeleteBlockMedia = ({
  blockMediaList,
  index,
  setBlockMediaList = () => undefined,
}) => {
  const updateBlockList = _.filter(blockMediaList, (prevItem, prevIndex) => {
    return prevIndex !== index;
  });
  setBlockMediaList(updateBlockList);
};
